import { motion } from "framer-motion";
import SectionTitle from "../ui/SectionTitle";
import {
  FaReact,
  FaWordpress,
  FaRocket,
  FaSearch,
  FaShoppingCart,
  FaTools,
} from "react-icons/fa";

const services = [
  {
    icon: <FaReact />,
    title: "React Development",
    description:
      "Build scalable single-page applications with reusable components, clean architecture, and exceptional performance.",
  },
  {
    icon: <FaRocket />,
    title: "Next.js Development",
    description:
      "Develop SEO-friendly, lightning-fast websites using server-side rendering, static generation, and modern React features.",
  },
  {
    icon: <FaWordpress />,
    title: "WordPress Development",
    description:
      "Create custom WordPress themes, plugins, ACF-powered websites, and headless WordPress solutions.",
  },
  {
    icon: <FaShoppingCart />,
    title: "WooCommerce",
    description:
      "Develop secure ecommerce websites with custom checkout flows, payment gateways, filters, and optimized shopping experiences.",
  },
  {
    icon: <FaSearch />,
    title: "SEO & Performance",
    description:
      "Improve Core Web Vitals, page speed, accessibility, technical SEO, structured data, and search visibility.",
  },
  {
    icon: <FaTools />,
    title: "Maintenance & Support",
    description:
      "Ongoing updates, security improvements, bug fixes, backups, feature enhancements, and long-term technical support.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      className="section relative overflow-hidden bg-[#07101f]"
    >
      {/* Background */}
      <div className="absolute left-0 top-0 h-96 w-96 rounded-full bg-blue-600/10 blur-[140px]" />
      <div className="absolute right-0 bottom-0 h-96 w-96 rounded-full bg-cyan-500/10 blur-[140px]" />

      <div className="container">

        <SectionTitle
          subtitle="Services"
          title="Solutions Designed for Modern Businesses"
        />

        <div className="max-w-3xl mb-16">
          <p className="text-lg leading-8 text-slate-400">
            From business websites to enterprise applications, I build
            responsive, high-performance digital experiences that are fast,
            secure, SEO-friendly, and designed to grow with your business.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3">

          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.5,
                delay: index * 0.08,
              }}
              viewport={{ once: true }}
              className="group relative overflow-hidden rounded-3xl border border-white/10 bg-white/5 p-8 backdrop-blur-lg transition-all duration-500 hover:-translate-y-3 hover:border-blue-500"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-blue-600/0 to-cyan-500/0 opacity-0 transition duration-500 group-hover:from-blue-600/10 group-hover:to-cyan-500/10 group-hover:opacity-100" />

              <div className="relative z-10">
                <div className="mb-8 flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-600 text-3xl text-white shadow-lg">
                  {service.icon}
                </div>

                <h3 className="mb-5 text-2xl font-bold">
                  {service.title}
                </h3>

                <p className="leading-8 text-slate-400">
                  {service.description}
                </p>

                {/* <div className="mt-8">
                  <span className="inline-flex items-center text-blue-400 transition group-hover:translate-x-2">
                    Learn More →
                  </span>
                </div> */}
              </div>
            </motion.div>
          ))}

        </div>

        {/* CTA */}

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-24 overflow-hidden rounded-[32px] border border-blue-500/20 bg-gradient-to-r from-blue-600/20 via-slate-900 to-cyan-600/20 p-10 lg:flex lg:items-center lg:justify-between"
        >
          <div>
            <h3 className="text-3xl font-bold">
              Need a high-performance website?
            </h3>

            <p className="mt-4 max-w-2xl text-slate-300 leading-8">
              Whether you need a React application, a Next.js website,
              a WordPress solution, or a complete redesign, I can help
              transform your ideas into a fast, scalable, and visually
              impressive digital product.
            </p>
          </div>

          <a
            href="#contact"
            className="mt-8 inline-flex rounded-xl bg-blue-600 px-8 py-4 font-semibold transition hover:bg-blue-700 lg:mt-0"
          >
            Start Your Project
          </a>
        </motion.div>

      </div>
    </section>
  );
}